<template>
  <div :id="id">
    <b-container>
      <div class="mb-2 hidden-print row">
        <div class=" offset-md-9">
          <Print :elementToPrintId="id"></Print>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <p>Zał 1 do PS-07</p>
        </div>
        <div class="col">

          <img src="surovital_logo.jpg" class="logo">
        </div>
      </div>

      <table class="table-sm" style="border-bottom: 1px solid black; width: 100%;">
        <tr>
          <td>
            <p>Wersja 3 z dnia 05.04.2023</p>
          </td>
          <td>
            <h4>Karta kontroli dostawy</h4>
          </td>
        </tr>
      </table>

      <div class="d-flex justify-content-center">
        <h4>Formularz monitorowania punktu oPRP1</h4>
      </div>

      <table class="table-sm">
        <tr>
          <td class="grid-border delivery-form-header">Numer Partii:</td>
          <td class="grid-border">{{ src.batchNumber }}</td>
          <td class="grid-border delivery-form-header">Data dostawy:</td>
          <td class="grid-border">{{ src.deliveryDate | moment("DD-MM-YYYY HH:mm") }}</td>
        </tr>
        <tr>
          <td class="grid-border delivery-form-header">Surowiec:</td>
          <td class="grid-border">
            {{ src.rawMaterialTypeName }} <br>
            {{ src.productType == rawMaterialTypeEko ? "EKO" : "KONWENCJA" }}
          </td>

          <td class="grid-border delivery-form-header">Wielkość dostawy w kg:</td>
          <td class="grid-border" colspan="3">{{ src.deliveryWeight }}</td>
        </tr>

        <tr>
          <td class="grid-border delivery-form-header">Rodzaj opakowania:</td>
          <td class="grid-border">
            <span v-if="src.isPackedHermetically">Hermetycznie</span>
            <span v-if="!src.isPackedHermetically">Niehermetycznie</span>
            <br />
            {{ src.packageTypeName }}
          </td>
          <td class="grid-border delivery-form-header">
            Sposób pakowania <br />
            Ilość {{ src.deliveryPackageTypeName }}
          </td>
          <td class="grid-border">
            ({{ src.numberOfMaterialsInPackage }}x{{
              src.rawMaterialWeightInPackage
            }}kg)
            <br />
            {{ src.numberOfPackages }}
          </td>
        </tr>

        <tr>
          <td class="grid-border delivery-form-header">
            Data ważności surowca: <br />
            Numer Partii:
          </td>
          <td class="grid-border">{{ src.rawMaterialExpireDate | moment("DD-MM-YYYY HH:mm") }} <br />
            {{ src.serialNumber }}
          </td>

          <td class="grid-border delivery-form-header">Nazwa i numer dokumentu dostawy:</td>
          <td class="grid-border" colspan="3">
            <span v-if="src.invoiceType == 0">Fv </span>
            <span v-if="src.invoiceType == 1">Wz </span>
            {{ src.invoiceNumber }}
          </td>
        </tr>

        <tr>
          <td class="grid-border delivery-form-header">
            Dostawca <br />
            Kraj pochodzenia surowca:
          </td>
          <td class="grid-border">
            {{ src.producer.nameWithActiveCertificate }} <br />
            {{ src.countryName }}
          </td>
          <td class="grid-border delivery-form-header">Środek transportu / Numer rejestracyjny:</td>
          <td class="grid-border">Auto dostawcze / {{ src.vehicleIdentifier }}</td>
        </tr>

        <tr>
          <td class="grid-border delivery-form-header">Wartości docelowe</td>
          <td class="grid-border" colspan="3">
            Szkodniki: brak obecności szkodników, brak śladów bytowania szkodników
            <br />
            Zanieczyszczenia: brak jakichkolwiek zaniczyszczeń <br />
            Stan opakowań: bez uszkodzeń, zabrudzeń <br />
            Barwa: swoista, typowa <br />
            Zapach: brak obcych posmaków i zapachów
          </td>
        </tr>

        <tr>
          <td class="grid-border delivery-form-header">Odpowiedzialność za monitorowanie</td>
          <td class="grid-border" colspan="3">
            Osoba odpowiedzialna za przyjęcie i kontrolę surowca
          </td>
        </tr>

        <tr>
          <td class="grid-border delivery-form-header">Częstotliwość monitorowania</td>
          <td class="grid-border" colspan="3">Dla każdej partii - dostawy ziaren lub bakalii</td>
        </tr>
      </table>


      <h5 class="pt-4 pb-4">I. Kontrola jakości</h5>

      <table class="table-sm" style="width: 100%;">
        <tr>
          <th style="width: 25%;" class="grid-border">Pytanie</th>
          <th style="width: 10%;" class="grid-border ">Tak</th>
          <th style="width: 10%;" class="grid-border">Nie</th>
          <th class="grid-border " style="text-align: center, width: 55%;">Uwagi</th>
        </tr>
        <tr v-for="item in src.deliveryQuestions" :src="item" :key="item.id">
          <td class="grid-border delivery-form-header ">{{ item.text }}</td>
          <td class="grid-border"><span v-if="item.isPassed">X</span></td>
          <td class="grid-border "><span v-if="!item.isPassed">X</span></td>
          <td class="grid-border ">
            <span v-if="!item.comment">Brak</span>
            <span v-if="item.comment">{{ item.comment }}</span>
          </td>
        </tr>
      </table>


      <h5 class="pt-4 pb-4">II. Mykotosyny - na podstawie atestu/deklaracji dostawcy</h5>

      <table class="table-sm" style="width: 100%;">
        <tr>
          <td class="grid-border delivery-form-header col-md-4" style="width: 25%;">Decyzja o przyjęciu:</td>
          <td class="grid-border " style="width: 75%;">
            <span v-if="src.isDeliveryApproved">Przyjęte</span>
            <span v-if="!src.isDeliveryApproved">Nie przyjęte</span>
          </td>
        </tr>

        <tr>
          <td class="grid-border delivery-form-header col-md-4" style="width: 50%;">Podjęte działania korygujące w
            przypadku niezgodności:
          </td>
          <td class="grid-border " style="width: 50%;">
            <span v-if="!src.deliveryMissMatchComment">Brak</span>
            <span v-if="src.deliveryMissMatchComment">{{ src.deliveryMissMatchComment }}</span>
          </td>
        </tr>
      </table>

      <div class="row">
        <div class="col-md-6 offset-md-6">
          <div class="signature">
            ......................................................<br />
            Podpis
          </div>
        </div>
      </div>

      <table class="table-sm" style="width: 100%;">
        <tr>
          <td class="grid-border delivery-form-header col-md-4" style="width: 50%;">
            Zweryfikowano zgodność certyfikatu ekologicznego dostawcy w systemie TRACES, certyfikat ważny w momencie zakupu towaru.
          </td>
          <td class="grid-border " style="width: 50%;">
            Uwagi: {{ src.productType == rawMaterialTypeKonwencja ? "Nie dotyczy" : "Brak" }}
          </td>
        </tr>
      </table>

      <div class="row">
        <div class="col-md-6 offset-md-6">
          <div class="signature">
            ......................................................<br />
            Podpis osoby weryfikującej
          </div>
        </div>
      </div>
      <div v-if="!isLast" class="pagebreak"></div>
    </b-container>
  </div>
</template>

<script>
import Print from '../../Common/Print.vue'
import DeliveryMixins from '../../../mixins/delivery'

export default {
  name: "DeliverySummaryForm",
  mixins: [DeliveryMixins],
  data() {
    return {
      id: this._uid
    };
  },
  components: { Print },
  props: ["src","isLast"],
};
</script>
